import { GetCardListRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/card_list';
import { convertYearMonthDayToDate } from '@banking/ui/utils/datetime-converter';
const INITIAL_STATE = {
  allowMultipleCards: false,
  cards: [],
  canInviteOrOrderNewCard: false,
  hasError: false,
  isLoading: true,
  tooltipText: '',
  cardTokenWithReplacementDueDate: null,
  unitToken: ''
};
export const createState = (state = {}) => ({
  ...INITIAL_STATE,
  ...state
});
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["CardListReceived"] = "CARD_LIST/CARD_LIST_RECEIVED";
  ActionType["CardListRejected"] = "CARD_LIST/CARD_LIST_REJECTED";
  ActionType["RequestCardList"] = "CARD_LIST/REQUEST_CARD";
  ActionType["UserClickAddDebitCard"] = "CARD_LIST/USER_CLICK_ADD_DEBIT_CARD";
  return ActionType;
}({});
export let ActionCreator;
(function (_ActionCreator) {
  const cardListReceived = _ActionCreator.cardListReceived = response => ({
    type: ActionType.CardListReceived,
    response
  });
  const cardListRejected = _ActionCreator.cardListRejected = error => ({
    type: ActionType.CardListRejected,
    error
  });
  const requestCardList = _ActionCreator.requestCardList = () => ({
    type: ActionType.RequestCardList
  });
  const userClickAddDebitCard = _ActionCreator.userClickAddDebitCard = () => ({
    type: ActionType.UserClickAddDebitCard
  });
})(ActionCreator || (ActionCreator = {}));
const handleCardListReceived = (state, action) => {
  const {
    response
  } = action;
  const {
    cards,
    allowOrderNewCard,
    informationBannerText
  } = response;
  // If there are multiple expiring cards, pick the one that's expiring soon.
  const cardTokenWithReplacementDueDate = cards.map(c => {
    const repDueDate = c.orderedCard?.cardReplacement?.replacementDueDate;
    return {
      token: c.orderedCard?.cardToken,
      due: repDueDate ? convertYearMonthDayToDate(repDueDate) : undefined
    };
  }).filter(c => Boolean(c.due && c.token)).sort((a, b) => a.due.getTime() - b.due.getTime())?.[0]?.token ?? null;
  return [{
    ...state,
    cards,
    cardTokenWithReplacementDueDate,
    canInviteOrOrderNewCard: allowOrderNewCard,
    tooltipText: informationBannerText,
    hasError: false,
    isLoading: false
  }, null];
};
const handleCardListRejected = (context, state, action) => {
  const {
    error
  } = action;
  context.sentry.captureException(error);
  return [{
    ...state,
    hasError: true,
    isLoading: false
  }, null];
};
const handleRequestCardList = (context, state) => {
  if (state.unitToken.length <= 0) {
    context.sentry.captureException('workflow/balance/card-list - Unit token is empty');
    return [{
      ...state,
      hasError: true,
      isLoading: false
    }, null];
  }
  const work = () => context.getCardList(GetCardListRequest.create({
    unitToken: state.unitToken
  })).then(ActionCreator.cardListReceived, ActionCreator.cardListRejected);
  return [{
    ...state,
    isLoading: true
  }, work];
};
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.CardListReceived:
      return handleCardListReceived(state, action);
    case ActionType.CardListRejected:
      return handleCardListRejected(context, state, action);
    case ActionType.RequestCardList:
      return handleRequestCardList(context, state);
    case ActionType.UserClickAddDebitCard:
      return [state, null];
  }
};